const accordions = document.querySelectorAll('.faq .accordion');

accordions.forEach((accordion) => {
  accordion.addEventListener('click', () => {
    const img = accordion.querySelector('img');
    const isOpen = !accordion.classList.toggle('closed');

    if (isOpen) {
      img.src = '/assets/images/dash-black.svg';
    } else {
      img.src = '/assets/new/icons/plus-small.svg';
    }
  });
});
